import axiosInstance from "@API/axios";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "@Redux/snackBarSlice";

const usePaginate = () => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const getPage = (URL, err, queryOptions = {}, filterModel = {}) => {
        setLoading(true);
        return axiosInstance
            .post(`${URL}?${new URLSearchParams(queryOptions)}`, filterModel)
            .then((response) => {
                setLoading(false);
                return response.data;
            })
            .catch((error) => {
                dispatch(
                    setSnackbar({
                        open: true,
                        message: err,
                        error: true,
                    })
                );
                setLoading(false);
                throw error;
            });
    };

    return { loading, getPage };
};

export default usePaginate;
